export const test = `<h1>test 1</h1>
<p>test2<p>`;
